"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
require('es6-promise').polyfill();
require('./polyfills').pollyfill();
__export(require('./core/sayt'));



/*****************
 ** WEBPACK FOOTER
 ** ./~/sayt/dist/index.js
 ** module id = 197
 ** module chunks = 0
 **/